import React, { ReactNode, useLayoutEffect } from 'react';
import styled from 'styled-components';

import { useModalTitleContext } from '@/ui/Modal/ModalTitleContext';

const TitleStyled = styled.h2`
  grid-area: title;
  margin: 0;
  align-self: center;
  ${(p) => p.theme.typography.title3}
  color: ${(p) => p.theme.colors.neutral.onBackground};
`;

type TitleProps = {
  children: ReactNode;
  className?: string;
};

/**
 * Names the dialog. The heading carries the id the modal points `aria-labelledby` at, and tells
 * the modal it is there so the reference is only made while the heading exists (WCAG 4.1.2).
 */
export const Title = ({ children, className }: TitleProps): JSX.Element => {
  const modal = useModalTitleContext();

  useLayoutEffect(() => {
    modal?.setHasTitle(true);
    return () => modal?.setHasTitle(false);
  }, [modal]);

  return (
    <TitleStyled id={modal?.titleId} className={className}>
      {children}
    </TitleStyled>
  );
};
